<template>
  <div class="check-users-item-operation" :style="itemStyle" @click="removeMember">
    <span class="operation">-</span>
    <span>移出</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CheckUserItemRemove',
  components: {  },
  props: {
    itemStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    checkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    ...mapState({
      imTeamMemberRemoveVisible: state => state.imTeamMemberRemoveVisible
    })
  },
  watch: {
  },
  data () {
    return {
    }
  },
  methods: {
    removeMember () {
      this.$store.dispatch('changeImTeamMemberRemoveVisibleAction', !this.imTeamMemberRemoveVisible)
    }
  }
}
</script>

<style lang="stylus" scoped>
.check-users-item-operation {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
  cursor: pointer;
}
.operation {
  width: 28px;
  height: 28px;
  line-height: 28px
  font-size: 20px;
  text-align: center;
  border: 1px dashed;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/CheckUserItemRemove.vue